import {switchMap} from "rxjs/operators";
import {ofType} from "redux-observable";

import * as actionTypes from "../constants/actionTypes";
import * as methods from "../constants/methods";
import * as handlers from "../constants/handlers";

const getBarcodes = (action$) =>
    action$.pipe(
        ofType(actionTypes.GET_BARCODES_BY_PRODUCT_BASE_PACKAGE),
        switchMap(({payload}) => {
            if (payload.productName === null || payload.baseName === null || payload.packageName === null) {
                return [
                    {
                        type: actionTypes.RCC_REQUEST,
                        payload: {
                            type: methods.METHOD_MACHINE_GET_DIALOG
                        },
                        method: handlers.MACHINE_GET_DIALOG_AND_CONTINUE,
                        tabId: 0,
                        safe: true
                    }
                ];
            }

            return [
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_GET_BASE_IN_PRODUCT_PACKAGE_BARCODES,
                        params: {
                            productName: payload.productName,
                            baseName: payload.baseName,
                            packageName: payload.packageName
                        }
                    },
                    method: handlers.GET_BASE_IN_PRODUCT_PACKAGE_BARCODES,
                    tabId: 0
                }
            ];
        })
    );

export default [getBarcodes];
